import '../plugins/MobileNavPlugin.js';

// mobile menu init
export default function initMobileNav() {
	jQuery('body').mobileNav({
		menuActiveClass: 'main-nav-active',
		menuOpener: '.burger-btn',
		hideOnClickOutside: true,
		menuDrop: '.main-nav-wrap'
	}).mobileNav({
		menuActiveClass: 'partner-login-active',
		menuOpener: '.partner-login-opener, .partner-login-close',
		hideOnClickOutside: true,
		menuDrop: '.partner-login-wrap'
	}).mobileNav({
		menuActiveClass: 'search-form-active',
		menuOpener: '.search-form-opener, .search-form-close',
		menuDrop: '.search-form-wrap'
	}).mobileNav({
		menuActiveClass: 'portal-nav-active',
		menuOpener: '.mobile-burger-btn',
		hideOnClickOutside: true,
		menuDrop: '.header-portal-mobile-drop'
	}).mobileNav({
		menuActiveClass: 'category-active',
		menuOpener: '.category-main-opener, .category-close'
	});
}
